import { Icon, type IconSize } from "@captions-web/icons";

import { css, cx } from "~/styled-system/css";

export function Spinner({ size = 20, className }: { size?: IconSize; className?: string }) {
  return (
    <Icon
      name="gradient-loading"
      size={size}
      className={cx(
        css({
          animation: "token(animations.spin)",
          color: "white",
        }),
        className
      )}
    />
  );
}
